// extracted by mini-css-extract-plugin
export var dropdown = "_uk-0";
export var imageWrapper = "_uk-3";
export var itemNameContainer = "_uk-1";
export var productImage = "_uk-2";
export var spinnerWrapper = "_uk-4";